// Export Bootstrap to global window object
import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;
